<template>
  <div v-if="summary || (!loading && error)" class="ui-selection-summary" role="group" aria-label="Filter leads by stage" :aria-busy="String(loading)">
    <div v-if="!loading && error" class="ui-actions ui-actions--tight">
      <span role="alert">{{ error }}</span>
      <AppIconButton label="Retry loading stages" @click="$emit('retry')"><i class="pi pi-refresh" aria-hidden="true" /></AppIconButton>
    </div>
    <div v-for="(row, rowIndex) in stageRows" :key="rowIndex" class="ui-selection-summary__row">
      <button v-for="stage in row" :key="stage.code" type="button" class="ui-selection-summary__choice" :class="{ 'ui-selection-summary__choice--selected': isStageSelected(stage.code) }" :aria-pressed="String(isStageSelected(stage.code))" :aria-label="`${stage.name}: ${stage.count} leads`" @click="$emit('toggle-stage', stage.code)">
        <AppStatusBadge design="new" compact :color="stage.color" :label="`${stage.name} · ${stage.count}`" />
      </button>
    </div>
  </div>
</template>

<script>
import AppIconButton from '@/components/AppIconButton.vue'
export default {
  name: 'LeadFlowListSummary',
  components: { AppIconButton },
  props: {
    summary: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    selectedStages: { type: Array, default: () => [] }
  },
  computed: {
    stageRows() {
      if (!this.summary || !Array.isArray(this.summary.stages)) return []

      const stagesByCode = this.summary.stages.reduce((result, stage) => {
        result[stage.code] = stage
        return result
      }, {})
      const rowCodes = [
        ['new_lead', 'first_contact', 'engaged', 'consult', 'offer_negotiation', 'invoice_negotiation'],
        ['deposit_paid', 'postponed', 'full_paid', 'completed'],
        ['cancelled', 'nurture', 'spam', 'double_request']
      ]
      const knownCodes = new Set(rowCodes.flat())
      const rows = rowCodes.map(codes => codes.map(code => stagesByCode[code]).filter(Boolean))
      rows[2].push(...this.summary.stages.filter(stage => !knownCodes.has(stage.code)))
      return rows.filter(row => row.length)
    }
  },
  methods: {
    isStageSelected(stageCode) {
      return this.selectedStages.includes(stageCode)
    }
  }
}
</script>
